import axios from 'axios';
import { constructServiceURL } from '../../../../../utils/URLTools';

const apiFetchWeeklyThresholdsEdit = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'createThresholdModificationTransaction',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext.appContext,
    },
    params: {
      impcCode: payload.params.impcCode,
      weeks: payload.params.weeks,
      minThreshold: payload.params.minThreshold,
      maxThreshold: payload.params.maxThreshold,
    },
  });
  return axios.post(serviceUrl, payload.params);
};

export default apiFetchWeeklyThresholdsEdit;
